import { mergeProps as _mergeProps, createElementVNode as _createElementVNode, renderSlot as _renderSlot, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "custom-checkbox" }
const _hoisted_2 = ["value", "checked"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "custom-checkbox__checkmark" }, null, -1)
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = {
  key: 0,
  class: "auth__field-error"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Exclamation = _resolveComponent("Exclamation")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("label", _hoisted_1, [
      _createElementVNode("input", _mergeProps(_ctx.$attrs, {
        value: _ctx.modelValue,
        checked: _ctx.modelValue,
        onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:modelValue', $event.target.checked))),
        class: ["custom-checkbox__form-control", { 'custom-checkbox__form-control--error': _ctx.errorMsg }],
        type: "checkbox"
      }), null, 16, _hoisted_2),
      _hoisted_3,
      _renderSlot(_ctx.$slots, "default", {}, () => [
        _createElementVNode("span", { innerHTML: _ctx.label }, null, 8, _hoisted_4)
      ])
    ]),
    (_ctx.errorMsg)
      ? (_openBlock(), _createElementBlock("span", _hoisted_5, [
          _createVNode(_component_Exclamation),
          _createElementVNode("span", null, _toDisplayString(_ctx.errorMsg), 1)
        ]))
      : _createCommentVNode("", true)
  ], 64))
}